interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const baseBtn =
    "min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm font-medium transition-colors";

  return (
    <div className="flex items-center justify-center gap-2 mt-8 flex-wrap">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer`}
      >
        <i className="ri-arrow-left-s-line" /> 上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${baseBtn} cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer`}
      >
        下一页 <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}